/* import __COLOCATED_TEMPLATE__ from './social-data-item-display-component.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { capitalize } from '@ember/string';

export default Component.extend({
  classNames: ['kv__pair', 'u__cf', 'o__in-list'],
  displayName: computed('socialAccount.name', function () {
    if (this.socialAccount.name === 'linkedin') {
      return 'LinkedIn'; // we don't want to just camelize "linkedin". We want to capitalize both the L and the I.
    }
    return capitalize(this.socialAccount.name);
  }),
});
